import { actionTypes, errorTypes } from '@/types';

export default function setArticle({ getters, dispatch }, { articleID, endTour }) {
	const currentExhibition = getters.currentExhibition;
	let article;
	if (articleID) {
		article = currentExhibition.articleMap[articleID];
	}
	if (!article) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownArticle) });
		return;
	}
	const queryParams = Object.entries({ endTour }).reduce((acc, [paramKey, paramValue]) => {
		if (paramValue) acc.push(`${paramKey}=true`);
		return acc;
	}, []);
	dispatch(actionTypes.pushUrl, {
		// prettier-ignore
		url: `/${currentExhibition.exhibitionID}/${article.id}${queryParams.length ? `?${queryParams.join('&')}` : ''}`,
		replace: false,
	});
}
